export const MANUAL_RETURN_URL = "fqdnReturnUrl";